import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import {
  CommodityOfferLabels,
  CommodityOfferLayoutType,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEDHeaderComponent } from '../../partials/ed/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferUspListComponent } from '../../partials/shared/commodity-usp-list/commodity-usp-list.component';
import { CommonModule } from '@angular/common';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'ed-consumer-retention-minimal-commodity-offer',
  templateUrl: './ed-consumer-retention-minimal-commodity-offer.component.html',
  styleUrls: [
    './ed-consumer-retention-minimal-commodity-offer.component.ed.scss',
  ],
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEDHeaderComponent,
    CommodityOfferAccordionComponent,
    CommodityOfferUspListComponent,
    CSCaptureDirective,
    AutomationIdDirective,
    CommonModule,
    RoundedCurrencyPipe,
  ],
})
export class EdConsumerRetentionMinimalCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ensureHorizontalAlignment = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles? = false;
  @Output() selectOffer = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();
  @Output() openMoreInfo = new EventEmitter<void>();
}
